module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ebfac3f168323b5a72aa7562064b5e4c.png";